// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"251":"6565ad9bbaa8fbd909ab","348":"2efce6edb4e8adf0bdcf","885":"c4b99570b3a21345336d"}[chunkId] + ".js";
};